var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "base-setting" },
    [
      _c(
        "el-form",
        {
          ref: "baseForm",
          staticClass: "form",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "label-width": "150px",
            "label-position": "right",
            size: "small",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "页面类型：", prop: "type" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "form-control",
                  attrs: { placeholder: "请选择" },
                  on: { change: _vm.updateForm },
                  model: {
                    value: _vm.form.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "type", $$v)
                    },
                    expression: "form.type",
                  },
                },
                _vm._l(_vm.availablePageTypeEnum, function (item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "归属客户：" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "form-control",
                  attrs: {
                    filterable: "",
                    clearable: "",
                    placeholder: "请选择归属客户",
                  },
                  on: { change: _vm.updateForm },
                  model: {
                    value: _vm.form.customerId,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "customerId", $$v)
                    },
                    expression: "form.customerId",
                  },
                },
                _vm._l(_vm.customerList, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "来一票京东/山姆：", prop: "pageType" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "form-control",
                  attrs: { placeholder: "请选择" },
                  on: { change: _vm.updateForm },
                  model: {
                    value: _vm.form.pageType,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "pageType", $$v)
                    },
                    expression: "form.pageType",
                  },
                },
                _vm._l(_vm.pageDisplayTypeEnum, function (item, index) {
                  return _c("el-option", {
                    key: "pageType-" + index,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "页面名称：", prop: "name" } },
            [
              _c("el-input", {
                staticClass: "form-control",
                attrs: { placeholder: "请输入页面名称" },
                on: { change: _vm.updateForm },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "页面标题：", prop: "title" } },
            [
              _c("el-input", {
                staticClass: "form-control",
                attrs: { placeholder: "请输入页面标题" },
                on: { change: _vm.updateForm },
                model: {
                  value: _vm.form.title,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "title", $$v)
                  },
                  expression: "form.title",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "是否校验登录：" } },
            [
              _c("el-switch", {
                attrs: {
                  "active-value": 1,
                  "inactive-value": 0,
                  "active-text": "是",
                  "inactive-text": "否",
                },
                on: { change: _vm.updateForm },
                model: {
                  value: _vm.form.canLogin,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "canLogin", $$v)
                  },
                  expression: "form.canLogin",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { staticClass: "set-bg", attrs: { label: "背景设置：" } },
            [
              _c("div", { staticClass: "bg-checkbox" }, [
                _c(
                  "div",
                  { staticClass: "flex" },
                  [
                    _c(
                      "el-checkbox",
                      {
                        staticClass: "mr-30",
                        attrs: { label: "bgImg" },
                        on: { change: _vm.updateForm },
                        model: {
                          value: _vm.form.isBgImg,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "isBgImg", $$v)
                          },
                          expression: "form.isBgImg",
                        },
                      },
                      [_vm._v("背景图片")]
                    ),
                    _vm._v(" "),
                    _vm.userType === 1
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "upLoadPicBox",
                                on: {
                                  click: function ($event) {
                                    return _vm.modalPicTap("1", "bgImg")
                                  },
                                },
                              },
                              [
                                _vm.form.bgImg
                                  ? _c("div", { staticClass: "pictrue" }, [
                                      _c("img", {
                                        attrs: { src: _vm.form.bgImg, alt: "" },
                                      }),
                                    ])
                                  : _c("div", { staticClass: "upLoad" }, [
                                      _c("i", {
                                        staticClass:
                                          "el-icon-camera cameraIconfont",
                                      }),
                                    ]),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.form.bgImg
                              ? _c("i", {
                                  staticClass: "el-icon-delete delete-icon",
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeImg("bgImg")
                                    },
                                  },
                                })
                              : _vm._e(),
                          ]
                        )
                      : _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                            },
                          },
                          [
                            _c(
                              "el-upload",
                              {
                                staticClass: "avatar-uploader-small",
                                attrs: {
                                  action: "",
                                  "show-file-list": false,
                                  "http-request": function (options) {
                                    return _vm.handleLocalUpload(
                                      options,
                                      "bgImg"
                                    )
                                  },
                                  "before-upload": _vm.beforeUpload,
                                  accept: "image/*",
                                },
                              },
                              [
                                _vm.form.bgImg
                                  ? _c("img", {
                                      staticClass: "avatar-small",
                                      attrs: { src: _vm.form.bgImg },
                                    })
                                  : _c("i", {
                                      staticClass:
                                        "el-icon-plus avatar-uploader-icon-small",
                                    }),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.form.bgImg
                              ? _c("i", {
                                  staticClass: "el-icon-delete delete-icon",
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeImg("bgImg")
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex" },
                  [
                    _c(
                      "el-checkbox",
                      {
                        staticClass: "mr-30",
                        attrs: { label: "bgColor" },
                        on: { change: _vm.updateForm },
                        model: {
                          value: _vm.form.isBgColor,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "isBgColor", $$v)
                          },
                          expression: "form.isBgColor",
                        },
                      },
                      [_vm._v("背景颜色")]
                    ),
                    _vm._v(" "),
                    _c("el-color-picker", {
                      attrs: { "show-alpha": "", size: "small" },
                      on: { change: _vm.updateForm },
                      model: {
                        value: _vm.form.bgColor,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "bgColor", $$v)
                        },
                        expression: "form.bgColor",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex" },
                  [
                    _c(
                      "el-checkbox",
                      {
                        staticClass: "mr-30",
                        attrs: { label: "bgColor" },
                        on: { change: _vm.updateForm },
                        model: {
                          value: _vm.form.isTextColor,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "isTextColor", $$v)
                          },
                          expression: "form.isTextColor",
                        },
                      },
                      [_vm._v("文字颜色")]
                    ),
                    _vm._v(" "),
                    _c("el-color-picker", {
                      attrs: { "show-alpha": "", size: "small" },
                      on: { change: _vm.updateForm },
                      model: {
                        value: _vm.form.textColor,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "textColor", $$v)
                        },
                        expression: "form.textColor",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "弹出广告：" } }, [
            _c(
              "div",
              { staticClass: "flex" },
              [
                _c(
                  "el-checkbox",
                  {
                    staticClass: "mr-30",
                    on: { change: _vm.updateForm },
                    model: {
                      value: _vm.form.isAdImg,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "isAdImg", $$v)
                      },
                      expression: "form.isAdImg",
                    },
                  },
                  [_vm._v("开启弹出广告")]
                ),
                _vm._v(" "),
                _vm.userType === 1
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "upLoadPicBox",
                            on: {
                              click: function ($event) {
                                return _vm.modalPicTap("1", "adImg")
                              },
                            },
                          },
                          [
                            _vm.form.adImg
                              ? _c("div", { staticClass: "pictrue" }, [
                                  _c("img", {
                                    attrs: { src: _vm.form.adImg, alt: "" },
                                  }),
                                ])
                              : _c("div", { staticClass: "upLoad" }, [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-camera cameraIconfont",
                                  }),
                                ]),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.form.adImg
                          ? _c("i", {
                              staticClass: "el-icon-delete delete-icon",
                              on: {
                                click: function ($event) {
                                  return _vm.removeImg("adImg")
                                },
                              },
                            })
                          : _vm._e(),
                      ]
                    )
                  : _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                        },
                      },
                      [
                        _c(
                          "el-upload",
                          {
                            staticClass: "avatar-uploader-small",
                            attrs: {
                              action: "",
                              "show-file-list": false,
                              "http-request": function (options) {
                                return _vm.handleLocalUpload(options, "adImg")
                              },
                              "before-upload": _vm.beforeUpload,
                              accept: "image/*",
                            },
                          },
                          [
                            _vm.form.adImg
                              ? _c("img", {
                                  staticClass: "avatar-small",
                                  attrs: { src: _vm.form.adImg },
                                })
                              : _c("i", {
                                  staticClass:
                                    "el-icon-plus avatar-uploader-icon-small",
                                }),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.form.adImg
                          ? _c("i", {
                              staticClass: "el-icon-delete delete-icon",
                              on: {
                                click: function ($event) {
                                  return _vm.removeImg("adImg")
                                },
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _vm.form.isAdImg
            ? _c(
                "el-form-item",
                { attrs: { label: "广告时间：", prop: "duration" } },
                [
                  _c(
                    "el-input",
                    {
                      staticClass: "form-control",
                      attrs: {
                        type: "number",
                        min: 0,
                        placeholder: "请输入广告时间",
                      },
                      on: { change: _vm.updateForm },
                      nativeOn: {
                        keydown: function ($event) {
                          return _vm.blockInvalidNumberKey($event)
                        },
                      },
                      model: {
                        value: _vm.form.duration,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "duration", $$v)
                        },
                        expression: "form.duration",
                      },
                    },
                    [_c("template", { slot: "append" }, [_vm._v("秒")])],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.form.isAdImg
            ? _c(
                "el-form-item",
                { attrs: { label: "跳转链接：", prop: "advUrl" } },
                [
                  _c("JumpNative", {
                    staticClass: "form-control",
                    on: { change: _vm.updateForm },
                    model: {
                      value: _vm.form.advUrl,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "advUrl", $$v)
                      },
                      expression: "form.advUrl",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.form.isAdImg
            ? _c(
                "el-form-item",
                { attrs: { label: "间隔时间：", prop: "adInterval" } },
                [
                  _c(
                    "el-input",
                    {
                      staticClass: "form-control",
                      attrs: {
                        type: "number",
                        min: 0,
                        placeholder: "请输入间隔时间",
                      },
                      on: { change: _vm.updateForm },
                      nativeOn: {
                        keydown: function ($event) {
                          return _vm.blockInvalidNumberKey($event)
                        },
                      },
                      model: {
                        value: _vm.form.adInterval,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "adInterval", $$v)
                        },
                        expression: "form.adInterval",
                      },
                    },
                    [_c("template", { slot: "append" }, [_vm._v("小时")])],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }